import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const StepStatus = ({
  available,
  review,
  valid,
}: {
  available?: boolean
  review?: boolean
  valid?: boolean
}) => {
  const { t } = useTranslation('@cibo/impact/StepStatus')

  return review ? (
    <Typography variant="caption">{t('review')}</Typography>
  ) : available ? (
    <Typography color={valid ? 'success.main' : 'warning.main'} variant="caption">
      {valid ? t('complete') : t('incomplete')}
    </Typography>
  ) : (
    <Typography variant="caption">{t('unavailable')}</Typography>
  )
}
